import React from 'react';
import PropTypes from 'prop-types';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { Field } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import HighlightView from './View';
import messages from '../../../../messages';

const HighlightSidebar = ({ data = {}, block, onChangeBlock }) => {
  const intl = useIntl();

  const handle = (id, value) => {
    onChangeBlock(block, { ...data, [id]: value });
  };

  return (
    <div className="ui form">
      <header className="sidebar-header">
        <h2>FCMH: Highlight</h2>
      </header>

      <fieldset>
        <legend>Inhalt</legend>

        <Field
          id="image"
          title={intl.formatMessage(messages.headerBackgroundImage)}
          widget="object_browser"
          mode="image"
          value={data.image || null}
          onChange={handle}
        />

        <Field
          id="title"
          title={intl.formatMessage(messages.headerTitle)}
          value={data.title || ''}
          onChange={handle}
        />

        <Field
          id="description"
          title={intl.formatMessage(messages.headerDescription)}
          widget="textarea"
          value={data.description || ''}
          onChange={handle}
        />

        <Field
          id="buttonLabel"
          title="Button-Text"
          value={data.buttonLabel || ''}
          onChange={handle}
        />

        <Field
          id="buttonLink"
          title="Button-Link"
          widget="object_browser"
          mode="link"
          allowExternals
          value={data.buttonLink || null}
          onChange={handle}
        />

        <Field
          id="fixedHeight"
          title={intl.formatMessage(messages.fcmhHighlightHeight)}
          type="boolean"
          value={Boolean(data.fixedHeight)}
          onChange={handle}
        />

        <Field
          id="content_half_width"
          title={intl.formatMessage(messages.fcmhHighlight50Cap)}
          type="boolean"
          value={Boolean(data.content_half_width)}
          onChange={handle}
        />

        <Field
          id="content_horizontal_alignment"
          title={intl.formatMessage(messages.fcmhHorizontalAlignment)}
          widget="select"
          value={data.content_horizontal_alignment || 'left'}
          onChange={handle}
          choices={[
            ['left', intl.formatMessage(messages.fcmhHighlightLeft)],
            ['center', intl.formatMessage(messages.fcmhHighlightMiddle)],
            ['right', intl.formatMessage(messages.fcmhHighlightRight)],
          ]}
        />

        <Field
          id="content_vertical_alignment"
          title={intl.formatMessage(messages.fcmhVerticalAlignment)}
          widget="select"
          value={data.content_vertical_alignment || 'bottom'}
          onChange={handle}
          choices={[
            ['top', intl.formatMessage(messages.fcmhHighlightTop)],
            ['center', intl.formatMessage(messages.fcmhHighlightMiddle)],
            ['bottom', intl.formatMessage(messages.fcmhHighlightBottom)],
          ]}
        />
      </fieldset>

      <fieldset>
        <Field
          id="background_color"
          title="Overlay-Farbe"
          description="Wähle die Overlay-Hintergrundfarbe."
          widget="fcmhColorSelect"
          value={data.background_color || 'purple'}
          onChange={handle}
          choices={[
            ['gray', 'Grau'],
            ['white', 'Weiß'],
            ['blue', 'Blau'],
            ['yellow', 'Gelb'],
            ['purple', 'Lila'],
          ]}
        />
      </fieldset>
    </div>
  );
};

const HighlightEdit = (props) => {
  const { data, selected, onChangeBlock, block } = props;

  return (
    <>
      <HighlightView data={data} mode="edit" />
      <SidebarPortal selected={selected}>
        <HighlightSidebar
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

HighlightEdit.propTypes = {
  data: PropTypes.object,
  selected: PropTypes.bool,
  onChangeBlock: PropTypes.func,
  block: PropTypes.string,
};

export default HighlightEdit;
